<script lang="ts">
  import { SearchState } from "../../services/search-service.js";

  export let datasetId;

  function handleSubmit(e) {
    e.preventDefault();

    const newParams = $SearchState.params

    if (datasetId) {
      newParams.delete("limit");
      newParams.delete("offset");
      newParams.set("datasetId", datasetId);

      // TODO: This almost certainly wants to be an changed to an <a>
      window.location.href = `../../find-a-station?${newParams}`;
    }
  }
</script>

<li class="m-2">
  <form role="search" on:submit={handleSubmit}>
    <button type="submit" class="fas-link-button">
      Open Find-A-Station <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </button>
  </form>
</li>

<style>
  .fas-link-button {
    all: unset;
    cursor: pointer;
    display: inline-block;
    position: relative;
    color: #0087ca;
    font-size: inherit;
  }

  .fas-link-button::after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #0087ca;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
  }

  .fas-link-button:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
</style>
